/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/aino_medium'
export default icon
